import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import React from 'react';
import GS from '../grafsync/grafsync';
import LoadingButton from './LoadingButton';
import PrimaryButton from './PrimaryButton';
import { makeCancelable } from './utils/utils';
import Warning from './Warning';

class HistoryDownload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isErrored: false,
            open: false
        };
        this.cancellable = null;
    }

    doDownload(resource, graph, path, isReversed, startDate, endDate, users, format) {
        this.cancellable = makeCancelable(GS.downloadHistory(resource, graph, path, isReversed, startDate, endDate, users, 10000, 0, format));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    downloadHistory = async (format) => {
        this.setState({ isLoading: true });
        this.doDownload(this.props.resource, this.props.graph, this.props.path, this.props.isReversed, this.props.startDate, this.props.endDate, this.props.users, format)
            .promise
            .then(() => {
                if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isLoading: false });
            })
            .catch(() => {
                if (this.cancellable && !this.cancellable.isCancelled())
                    this.setState({
                        isErrored: true,
                        isLoading: false,
                        errorMessage: "Could not download history."
                    });
            });
    };

    onExitWarning = () => this.setState({ isErrored: false });

    showMenu = (ev) => {
        this.setState({
            anchorEl: ev.currentTarget,
            open: true
        });
    };

    handleClose = (format) => {
        this.setState({ open: false });
        if (format !== null) this.downloadHistory(format);
    };

    render() {

        const { isErrored, open, isLoading, errorMessage, anchorEl } = this.state;
        const { disabled } = this.props;

        if (isErrored) return <Warning message={errorMessage} onExitWarning={this.onExitWarning} />;

        return (
            <div>
                {isLoading ?
                    <LoadingButton disabled />
                    :
                    <div>
                        <PrimaryButton
                            dataTest="download-history"
                            endIcon={<KeyboardArrowDownIcon />}
                            disabled={isLoading || disabled}
                            onClick={this.showMenu}>Download</PrimaryButton>
                        <Menu
                            open={open}
                            anchorEl={anchorEl}
                            transformOrigin={{
                                horizontal: -5,
                                vertical: -46
                            }}
                            onClose={(ev) => {
                                ev.preventDefault();
                                ev.stopPropagation();
                                this.handleClose(null);
                            }}>
                            <MenuItem
                                data-test={"item-tsv"}
                                dense={true}
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    this.handleClose("text/tab-separated-values");
                                }}
                                value="tsv">Download TSV</MenuItem>
                            <MenuItem
                                data-test={"item-json"}
                                dense={true}
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    this.handleClose("application/json");
                                }}
                                value="json">Download JSON</MenuItem>
                        </Menu>
                    </div>
                }
            </div>
        );
    }
}

HistoryDownload.defaultProps = {
    isReversed: false
};

HistoryDownload.propTypes = {
    disabled: PropTypes.bool,
    resource: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    isReversed: PropTypes.bool,
    path:  PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    users: PropTypes.array
};

export default HistoryDownload;